export default "__VITE_ASSET__BB2bZJq8__"